import styled from 'styled-components';

import { IconArrowRightCircle } from 'components/icons/arrow-right-circle';
import { primitive } from 'styles/constants/primitives';

export const StyledForm = styled.form`
  margin-block-end: 0.5rem;
  width: 100%;
`;

export const AdditionalInformation = styled.div`
  color: ${Styles.color.primary};
  text-align: center;
  font-size: 0.9rem;
  margin-block-end: 2.5rem;
`;

export const DeliveryLogoContainer = styled.div`
  width: 10rem;
  margin-block-start: auto;
  margin-block-end: 0;
  margin-inline: auto;
`;

export const HelperText = styled.div`
  font-size: 0.8rem;
  white-space: initial;
  margin-block-start: -1rem;
  color: ${Styles.color.grey.three};
  padding: 0 0.2rem;
`;

export const AddressDetailsSection = styled.div`
  padding-block-end: 1rem;
`;

export const AddressDetailsBorder = styled.div`
  border-block-end: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 1rem 0;
  align-items: center;
`;

export const ChangeButton = styled.span`
  cursor: pointer;
  text-align: end;
  text-decoration: underline;
  font-family: ${Styles.fontFamily.body};
  font-size: 0.9rem;
  font-weight: normal;
`;

export const AddressWrapper = styled.div`
  white-space: initial;
`;

export const RightArrow = styled(IconArrowRightCircle)`
  position: absolute;
  inset-inline-end: 0;
  width: 2.5rem;
  height: 2.5rem;
  margin-block-start: -4.25rem;
  margin-inline-end: 0.25rem;
  padding: 0.5rem;
  z-index: 1000;
  background: ${primitive.$white};
  cursor: pointer;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;

  ${Styles.mobile} {
    gap: 0;
    flex-direction: column;
  }
`;

export const AddressNameLabel = styled.h2`
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  font-weight: ${Styles.fontWeight.normal};
  letter-spacing: 'normal';
  line-height: 1.11;
  font-size: 1rem;
  margin: 0;
  text-transform: ${Styles.textTransform.headlines};

  ${Styles.desktop} {
    font-size: 1.25rem;
  }
`;
